<template>
  <div class="d-flex justify-content-center">
    <div class="position-relative text-center p-4 rounded-4 shadow-lg mx-auto" style="
    background: linear-gradient(135deg, #1b3b4fcc, #0c2030e8);
    width: 100%;
    max-width: 400px;       /* límite máximo */
    min-width: 350px;       /* evita que se encoja */
    border-radius: 12px;
    overflow: hidden;
    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.06);
    transition: all 0.4s ease;
    min-height: 260px;
  ">
      <p class="fw-semibold text-white mb-4 fs-5">Cotiza tu página web</p>

      <!-- Transición entre pasos -->
      <transition name="fade" mode="out-in">
        <!-- PASO 1 -->
        <form v-if="step === 1" key="step1" @submit.prevent="nextStep" class="d-flex flex-column gap-3">
          <!-- Campo correo / teléfono -->
          <div class="position-relative">
            <input type="text" v-model="inputValue" placeholder="Correo o teléfono (10 dígitos)"
              class="form-control text-white" style="
                background-color: rgba(255,255,255,0.05);
                border: 1px solid rgba(255,255,255,0.1);
                border-radius: 0.75rem;
              " />
            <p v-if="errorInput" class="mt-1 small text-danger1">Ingresa un correo o teléfono válido</p>
          </div>

          <!-- Select de paquetes -->
          <div class="text-start">
            <label for="paquete" class="visually-hidden">Selecciona un paquete</label>
            <select v-model="selectedPackage" class="form-select text-white" id="paquete" style="
                background-color: rgba(255,255,255,0.05);
                border: 1px solid rgba(255,255,255,0.1);
                border-radius: 0.75rem;
              ">
              <option value="" disabled selected>Selecciona un paquete</option>
              <option v-for="pkg in packages" :key="pkg.id" :value="pkg.nombre" class="bg-dark text-white">
                {{ pkg.nombre }} — {{ pkg.precio }}
              </option>
            </select>
            <p v-if="errorPackage" class="mt-1 small text-danger1 text-center">Selecciona un paquete</p>
          </div>

          <!-- Botón -->
          <button type="submit"
            class="btn btn-success w-100 fw-semibold d-flex align-items-center justify-content-center gap-2"
            style="background: linear-gradient(90deg, #78ffd6, #a8ff78); border: none; color: #0c2030;">
            Continuar
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 21 20"
              stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M1 10h18M19 10l-5-5m5 5l-5 5" />
            </svg>
          </button>
        </form>

        <!-- PASO 2 -->
        <form v-else-if="step === 2" key="step2" @submit.prevent="handleSubmit" class="d-flex flex-column gap-3">
          <p class="text-white-100 small mb-2">Perfecto 🙌 solo un paso más...</p>

          <input type="text" v-model="nombre" placeholder="Escribe tu nombre completo"
            class="form-control text-white text-center" style="
              background-color: rgba(255,255,255,0.05);
              border: 1px solid rgba(255,255,255,0.1);
              border-radius: 0.75rem;
            " />
          <p v-if="errorNombre" class="mt-1 small text-danger1 text-center">Por favor ingresa tu nombre</p>

          <button type="submit"
            class="btn btn-success w-100 fw-semibold d-flex align-items-center justify-content-center gap-2 mt-2"
            style="background: linear-gradient(90deg, #78ffd6, #a8ff78); border: none; color: #0c2030;">
            Enviar datos
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 21 20"
              stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M1 10h18M19 10l-5-5m5 5l-5 5" />
            </svg>
          </button>
        </form>

        <!-- PASO 3 -->
        <div v-else key="step3" class="mt-4">
          <div class="alert  mt-3 p-2 py-3">
            ✅ ¡Gracias {{ nombre }}! Te contactaremos pronto sobre
            <strong>{{ selectedPackage }}</strong>.
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script setup>
import axios from 'axios'
import { ref } from 'vue'
import paquetesData from '@/assets/data/paquetes.json'
import { useReCaptcha } from 'vue-recaptcha-v3' // 👈 Importar hook

const { executeRecaptcha } = useReCaptcha() // 👈 Obtener la función

const paquetes = ref(paquetesData)
const inputValue = ref('')
const selectedPackage = ref('')
const nombre = ref('')
const errorInput = ref(false)
const errorPackage = ref(false)
const errorNombre = ref(false)
const step = ref(1)

const packages = ref(paquetes.value.map(pkg => ({
  id: pkg.nombre.toLowerCase().replace(/\s+/g, '-'),
  nombre: pkg.nombre,
  precio: pkg.precio
})))

const nextStep = async () => {
  const value = inputValue.value.trim()
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  const phoneRegex = /^[0-9]{10}$/

  errorInput.value = !(emailRegex.test(value) || phoneRegex.test(value))
  errorPackage.value = selectedPackage.value === ''

  if (!errorInput.value && !errorPackage.value) {
    // ✅ 1. DISPARAR CONVERSIÓN DE GOOGLE ADS
    // Verificamos si window.gtag existe (para evitar errores si un adblocker lo borró)
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'conversion', {
        'send_to': 'AW-1016280589/Y8m6CMjlz-gZEI3szOQD'
        // NOTA: Eliminé el 'event_callback' que redirigía la página, 
        // ya que tú controlas la navegación con step.value = 2
      });
      console.log('✅ Conversión enviada a Google Ads');
    }
    // ✅ Guardar lead en WordPress (blog.mitikuin.com)
    try {
      const res = await axios.post('https://blog.mitikuin.com/wp-json/mitikuin/v1/lead', {
        contacto: value,
        paquete: selectedPackage.value,
      })
      console.log('✅ Lead guardado en WordPress:', res.data)
    } catch (err) {
      console.error('❌ Error al guardar lead:', err)
    }
    step.value = 2
  }


}

const handleSubmit = async () => {
  const value = inputValue.value.trim()
  const paquete = selectedPackage.value
  const name = nombre.value.trim()

  errorNombre.value = !name
  if (errorNombre.value) return



  try {
    // ✅ Ejecutar reCAPTCHA
    const token = await executeRecaptcha('submit')

    const payload = { contacto: value, paquete, nombre: name, token }

    const res = await axios.post('https://mitikuin.com/api/recibir_datos.php', payload, {
      headers: { 'Content-Type': 'application/json' },
    })

    const res2 = await axios.post('https://blog.mitikuin.com/wp-json/mitikuin/v1/lead', {
      nombre: name,
      contacto: value,
      paquete: paquete
    })
    console.log('✅ Nombre actualizado en WordPress:', res2.data)

    if (res.data.status === 'success') {
      step.value = 3  // Mostrar mensaje de exito y mantener al usuario en la pagina

      // Esperar y regresar automaticamente al paso 1
      setTimeout(() => {
        step.value = 1
        inputValue.value = ''
        selectedPackage.value = ''
        nombre.value = ''
      }, 8000)
    }
  } catch (err) {
    console.error('❌ Error al conectar con el servidor:', err)
    alert('❌ No se pudo conectar con el servidor.')
  }
}
</script>


<style scoped>
::placeholder {
  color: rgba(255, 255, 255, 0.5) !important;
}

select option {
  background-color: #0c2030 !important;
}

.form-select:focus,
.form-control:focus {
  border-color: #a8ff78 !important;
  box-shadow: 0 0 0 0.25rem rgba(168, 255, 120, 0.25) !important;
}

.text-danger1 {
  color: #a8ff78;
}

/* ✨ Transición elegante entre pasos */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.6s ease, transform 0.4s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}
</style>
